import { render, staticRenderFns } from "./ConversationItemV2.vue?vue&type=template&id=d54f0360&scoped=true"
import script from "./ConversationItemV2.vue?vue&type=script&lang=js"
export * from "./ConversationItemV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationItemV2.vue?vue&type=style&index=0&id=d54f0360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54f0360",
  null
  
)

export default component.exports